import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import classNames from "classnames";
import { forwardRef } from "react";
export const LABEL_ELEMENT_TAG = "label";
const label = tailwindVariants({
    base: "block font-medium text-grey-10",
    variants: {
        size: {
            small: "text-12",
            medium: "text-14"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const Label = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, htmlFor, size, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("label", {
        className: label({
            size,
            class: classNames(htmlFor ? "cursor-pointer" : "cursor-auto", className)
        }),
        htmlFor: htmlFor,
        ref: forwardedRef,
        ...restOfProps
    });
});
Label.displayName = "Label";
